// Global state singleton - survives section re-renders
window.CartDrawerState = window.CartDrawerState || {
  isOpen: false,
  bodyClickHandler: null,
  keydownHandler: null,
  openDrawerHandler: null,
};

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.inner = this.querySelector('.cart-drawer__inner');
    this.cartIconBubble = document.querySelector('#cart-icon-bubble');

    this.onBodyClick = this.onBodyClick.bind(this);
    this.init();

    // Restore state after re-render
    if (window.CartDrawerState.isOpen) {
      this.classList.add('is-open');
      this.inner?.focus();
      // Remove any previous listener and re-attach
      document.removeEventListener(
        'click',
        window.CartDrawerState.bodyClickHandler
      );
      window.CartDrawerState.bodyClickHandler = this.onBodyClick;
      setTimeout(() => {
        document.addEventListener('click', this.onBodyClick);
      }, 100);
    }
  }

  init() {
    // Use event delegation for close button - survives innerHTML replacement
    this.addEventListener('click', (e) => {
      if (e.target.closest('#CartDrawer-Close, .cart-drawer__close')) {
        this.close();
      }
    });

    if (
      this.cartIconBubble &&
      this.cartIconBubble.getAttribute('role') === 'button'
    ) {
      this.cartIconBubble.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    }

    // Remove old keydown listener if exists, then add new one
    if (window.CartDrawerState.keydownHandler) {
      document.removeEventListener(
        'keydown',
        window.CartDrawerState.keydownHandler
      );
    }
    window.CartDrawerState.keydownHandler = (e) => {
      if (e.key === 'Escape' && window.CartDrawerState.isOpen) {
        this.close();
      }
    };
    document.addEventListener('keydown', window.CartDrawerState.keydownHandler);

    // Remove old cart:open-drawer listener if exists, then add new one
    if (window.CartDrawerState.openDrawerHandler) {
      document.removeEventListener(
        'cart:open-drawer',
        window.CartDrawerState.openDrawerHandler
      );
    }
    window.CartDrawerState.openDrawerHandler = (e) => {
      this.open();
    };
    document.addEventListener(
      'cart:open-drawer',
      window.CartDrawerState.openDrawerHandler
    );

    // Auto-open in theme editor if setting is enabled
    if (window.Shopify?.designMode && this.dataset.keepOpen === 'true') {
      this.open();

      // Re-open after section re-renders in theme editor
      document.addEventListener('shopify:section:load', (e) => {
        if (
          e.target.contains(this) ||
          e.target === this.closest('.shopify-section')
        ) {
          setTimeout(() => this.open(), 50);
        }
      });
    }
  }

  open() {
    this.inner = this.querySelector('.cart-drawer__inner');
    if (!this.inner) return;

    window.CartDrawerState.isOpen = true;
    this.classList.add('is-open');
    document.body.classList.add('overflow-hidden');

    try {
      this.inner.focus();
    } catch (e) {}

    window.CartDrawerState.bodyClickHandler = this.onBodyClick;
    setTimeout(() => {
      document.addEventListener('click', this.onBodyClick);
    }, 100);
  }

  close() {
    window.CartDrawerState.isOpen = false;
    this.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    document.removeEventListener('click', this.onBodyClick);
    document.dispatchEvent(new CustomEvent('cart:drawer-closed'));
  }

  onBodyClick(e) {
    // Refresh inner reference in case DOM was re-rendered
    this.inner = this.querySelector('.cart-drawer__inner');

    // If the drawer is not open, do nothing (safety check)
    if (!this.classList.contains('is-open')) return;

    // Check if the click is outside the inner drawer
    const isClickInside = this.inner?.contains(e.target);

    // Check if the click is on the trigger button (to prevent double-toggling)
    const isTrigger = e.target.closest('#cart-icon-bubble');

    if (!isClickInside && !isTrigger) {
      this.close();
    }
  }
}

customElements.define('cart-drawer', CartDrawer);
